import { render, staticRenderFns } from "./InsuranceSubProgramDeactivateModal.vue?vue&type=template&id=115fd610&scoped=true"
import script from "./InsuranceSubProgramDeactivateModal.vue?vue&type=script&lang=js"
export * from "./InsuranceSubProgramDeactivateModal.vue?vue&type=script&lang=js"
import style0 from "./InsuranceSubProgramDeactivateModal.vue?vue&type=style&index=0&id=115fd610&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "115fd610",
  null
  
)

export default component.exports